export const dominio = 'https://apifastsign.bignerds.dev/api';
export const server = 'https://apifastsign.bignerds.dev';
// export const dominio = 'http://127.0.0.1:8000/api';
// export const server = 'http://127.0.0.1:8000';